import React, { useEffect, useState } from 'react';
import { ACTION_CODE, callApp } from '../../utils/callApp';
import { PAGREE_CODE } from '../../utils/codeEnum';
import './index.css';



const ErrorTips:React.FC<{data:any,onClose:Function}> = (props)=> {
  setTimeout(()=>{
    props.onClose();
  },2000)
  useEffect(()=>{

  },[])
  //展示状态
  
  return (
    <>
      <div className="wrap_border">
         <div className="error_tips">{props.data.msg}</div>
      </div>
    </>
  );
}




export default ErrorTips;
